module.exports = __webpack_public_path__ + "static/media/hammer-war.bab2f7fb.svg";